import { urlConfig } from "../../config/urlConfig";
import { postCall } from "../httpService";

const AuthUpdate = urlConfig.AuthUpdate;
const GetPermissions = urlConfig.GetPermissions;
const UpdateAccountsBySwitch = urlConfig.UpdateAccountsBySwitch
const GetAccountByUserForEnv = urlConfig.GetAccountByUserForEnv
const GetRequesterAccountForEnv = urlConfig.GetRequesterAccountForEnv

export const getAuthUpdate = async (params: any) => {
  try {
    const response = await postCall(AuthUpdate, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const updateAccountsBySwitch = async (params: any) => {
  try {
    const response = await postCall(UpdateAccountsBySwitch, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const getPermissions = async (params: any) => {
  try {
    const response = await postCall(GetPermissions, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const getAccountByUserForEnv = async (params: any) => {
  try {
    const response = await postCall(GetAccountByUserForEnv, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};
export const getRequesterAccountForEnv = async (params: any) => {
  try {
    const response = await postCall(GetRequesterAccountForEnv, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};
